import { loadThemePageContent } from '../pluginComponentApi';

export default (editor, opts = {}) => {
  const cmd = editor.Commands;
  const {
    modalTitle,
    codeViewOptions,
    refs,
    commands,
    labels,
    placeholderContent,
    selectArrow,
    titles,
    project,
  } = opts;
  const { customHtmlCdns } = project;
  const { keyMarketPlaceCustomCode } = refs;
  const appendToContent = (target, content) => {
    if (content instanceof HTMLElement) {
      target.appendChild(content);
    } else if (content) {
      target.insertAdjacentHTML('beforeend', content);
    }
  };

  cmd.add(commands.theme_page_custom_code, {
    keyMarketPlaceCustomCode,
    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const target = this.target;
      if (target && target.get('editable')) {
        this.showThemePageCode(target);
      }
    },

    stop(editor) {
      editor.Modal.close();
    },

    async showThemePageCode(target) {
      const { editor, options } = this;
      const title = options.title || modalTitle;
      const content = await this.getContent();
      const code = target.get(keyMarketPlaceCustomCode) || '';
      editor.Modal.open({ title, content })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));
      this.getCodeViewer().setContent(code);
    },
    getPreContent() {},
    getPostContent() {},
    getBreakPoint() {
      const contentBreak = document.createElement('br');
      return contentBreak;
    },

    async getContent() {
      const { editor } = this;
      const content = document.createElement('div');
      const galleryDiv = document.createElement('div');
      const codeViewer = this.getCodeViewer();
      const pfx = editor.getConfig('stylePrefix');

      content.className = `${pfx}theme-page`;
      galleryDiv.className = `${pfx}theme-page-gallery-div row`;
      galleryDiv.id = `${pfx}theme-page-gallery-div`;

      appendToContent(content, this.getPreContent());
      appendToContent(galleryDiv, this.getPreContent());

      await this.loadThemePage(customHtmlCdns, galleryDiv);

      let childComponents = [galleryDiv, codeViewer.getElement()];
      this.appendChildComponentsToContent(content, childComponents);
      appendToContent(galleryDiv, this.getPostContent());
      appendToContent(content, this.getPostContent());
      codeViewer.refresh();
      setTimeout(() => codeViewer.focus(), 0);
      return content;
    },

    appendChildComponentsToContent(content, childrens) {
      childrens.forEach((child) => {
        if (child.id === '' || child.id === undefined) {
          child.style = `display: none; visibility: hidden; height: 0vh;`;
          content.appendChild(child);
        } else {
          content.appendChild(child);
          if (!child.className.includes('no-break')) {
            content.appendChild(this.getBreakPoint());
          }
          if (child.className.includes('two-break')) {
            content.appendChild(this.getBreakPoint());
          }
        }
      });
    },

    getContentActions() {
      const { editor } = this;
      const btn = document.createElement('button');
      const pfx = editor.getConfig('stylePrefix');
      btn.innerHTML = labels.buttonLabel;
      btn.className = `${pfx}btn-prim ${pfx}btn-import__theme-page btn btn-theme-submit btn-sm`;
      btn.title = titles.buttonTitle;
      btn.style = `float: right;`;
      btn.onclick = () => this.handleSave();
      return btn;
    },

    handleSave() {
      const { editor, target } = this;
      const code = this.getCodeViewer().getContent();
      target.set(keyMarketPlaceCustomCode, code);
      editor.Modal.close();
    },

    async loadThemePage(themePageSelectList, galleryDiv) {
      const { editor, options } = this;
      const pfx = editor.getConfig('stylePrefix');
      themePageSelectList = [];
      if (customHtmlCdns) {
        customHtmlCdns.forEach((html) => {
          let preThemeObj = {};
          const fileNames = html.urlOrTag.split('/');
          let fileName = fileNames[fileNames.length - 1];
          fileName = fileName.split('.')[0];
          preThemeObj['id'] = fileName;
          preThemeObj['url'] = html.urlOrTag;
          themePageSelectList.push(preThemeObj);
        });
      }

      galleryDiv.innerHTML = '';
      themePageSelectList.forEach((element) => {
        let attrTitle = document.createAttribute('title');
        attrTitle.value = `Click to select ${element.id}`;
        let componentImage = document.createElement('div');
        componentImage.id = `${pfx}theme-page-gallery-img-${element.id}`;
        componentImage.className = `gjs-block gjs-one-bg gjs-four-color-h`;
        componentImage.setAttributeNode(attrTitle);
        componentImage.innerHTML = `<div class="drapcode-compo-seventeen gjs-block-label gjs-block__drapcode-wrap">
        <div class="drap-on-six inner-html"><i style="font-size: x-large;" class="wb webconnect-newspaper"></i></div>
          <div class="drapcode-com-one">${element.id}</div>
        </div>
      `;
        componentImage.onclick = () => this.handleClick(element, galleryDiv);
        galleryDiv.appendChild(componentImage);
        galleryDiv.style = `display: flex; visibility:visible;`;
      });
    },

    async handleClick(selectedThemePage, galleryDiv) {
      const { editor, options } = this;
      const pfx = editor.getConfig('stylePrefix');
      const selectedImgComponent = document.querySelector(
        `div[id=${pfx}theme-page-gallery-img-${selectedThemePage.id}]`,
      );
      const selectCompContainer = selectedImgComponent.querySelector(`.inner-html`);
      selectCompContainer.classList.add('selected-themepage-comp');
      if (selectedImgComponent) {
        let mixedContent = await loadThemePageContent(selectedThemePage.url);
        this.getCodeViewer().setContent(mixedContent);
      } else {
        this.getCodeViewer().setContent(placeholderContent);
      }
      this.handleSave();
    },

    getCodeViewer() {
      const { editor } = this;
      if (!this.codeViewer) {
        this.codeViewer = editor.CodeManager.createViewer({
          codeName: 'htmlmixed',
          theme: 'hopscotch',
          readOnly: 0,
          ...codeViewOptions,
        });
      }

      return this.codeViewer;
    },
  });
};
